export default __webpack_public_path__ + "static/media/one.78729d0a.jpeg";